module.exports = __webpack_public_path__ + "static/img/home_bt0.e4d68e19.png";